import React, { useState, Fragment } from 'react';
import { withRouter } from 'react-router';
// chameleon
import ProgressBarPopover from './ProgressBarPopover';
import { renderPerformanceBar } from 'chameleon-src/components/results/utils/utils';
// legacy import
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { getPriorStudentsSubdir } from 'legacy-src/utility/utils';
import { computeAssignmentsReadyToScore } from 'chameleon-src/components/learnosity/utils/helpers';

import './SingleAssignmentProgress.scss';
import usePerformanceTiers from 'chameleon/src/hooks/usePerformanceTiers';

let SingleAssignmentProgress = (props) => {
  const {
    assignments = [],
    router: { routes, params },
  } = props;
  const { subject: subjectId } = params;

  const { performanceTiers } = usePerformanceTiers(subjectId);

  const assignment = assignments[0];
  const { students, progress: assignmentProgress } = assignment;

  const progress = {
    ...assignmentProgress,
    not_started: assignmentProgress.notStarted,
    student_scored: assignmentProgress.studentScored,
    ready_to_score: assignmentProgress.readyToScore,
    teacher_and_student_scored: assignmentProgress.teacherAndStudentScored,
  };

  const [learnosityReport, setLearnosityReport] = useState();

  const { loading } = performanceTiers;

  const resultsUrl = `/${subjectId}/assessments/results/${
    assignment.id
  }${getPriorStudentsSubdir(routes)}`;

  const assignmentsToScore = computeAssignmentsReadyToScore(progress);
  const assignmentProgressText =
    assignmentsToScore > 0
      ? `${assignmentsToScore} to Score`
      : 'Manage Assignment';

  const assignmentProgressLink = `/${subjectId}/assignments/progress/${
    assignment.id
  }${getPriorStudentsSubdir(routes)}`;

  if (assignment.results) {
    return (
      <Fragment>
        {learnosityReport && !loading ? (
          <div className="SingleAssignmentProgress">
            {renderPerformanceBar({
              performanceTiersData: performanceTiers,
              params,
              results: learnosityReport,
              assignment,
              students,
              showScoreIcon: true,
              performancePopoverProps: {
                resultsUrl,
                assignmentProgressLink,
                assignmentProgressText,
              },
            })}
          </div>
        ) : (
          <LoadingSpinner height={34} />
        )}
        <LearnosityProvider
          apiType="reports"
          initOptions={JSON.parse(assignment.results)}
          dataListener={setLearnosityReport}
        />
      </Fragment>
    );
  }

  return (
    <ProgressBarPopover
      progress={progress}
      assignment={assignment}
      routes={routes}
      subjectId={subjectId}
    />
  );
};
export default withRouter(SingleAssignmentProgress);
